"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pandeReportReducer = exports.pandeReportActions = exports.TYPES = exports.REPORT_TARGET_TYPE = exports.PERMISSION_KEY = exports.KAISHA_SOSHIKI_SELECT_MODE = exports.INIT_ICON_COLUMN = exports.FLAG = exports.CONTENTS = exports.CLOCECONTACT_ENTRY_TYPE = exports.ACTIONS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _WorkplaceInfo = require("../common/components/WorkplaceInfo");
var _Consts = require("../common/consts/Consts");
var _pandeReportUtil = _interopRequireDefault(require("../common/logics/pandeReportUtil"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Report';

/**
 * アクションタイプ
 */
const TYPES = exports.TYPES = {
  SET_CONTENT: PREFIX + 'SetContent',
  CHANGE_KAISHA_SOSHIKI_ENTRY_MODE: PREFIX + 'ChangeKaishaSoshikiEntryMode',
  SET_HAS_PROXY_PERMISSION: PREFIX + 'SetHasProxyPermission',
  SET_ADDITIONALS: PREFIX + 'SetAdditionals',
  SET_REPORT_STATUS: PREFIX + 'SetReportStatus',
  SET_ENTRIES: PREFIX + 'SetEntries',
  SET_KAISHA_SOSHIKI: PREFIX + 'SetKaishaSoshiki',
  CHANGE_REPORT_TARGET_TYPE: PREFIX + 'ChangeReportTargetType',
  APPEND_RECORD: PREFIX + 'AppendRecord',
  MODIFY_RECORD: PREFIX + 'ModifyRecord',
  DELETE_RECORD: PREFIX + 'DeleteRecord',
  SET_ENTRY: PREFIX + 'SetEntry',
  SET_OBJECT_ENTRY: PREFIX + 'SetChildEntry',
  SET_CHECKING_FLG: PREFIX + 'SetCheckingFlg',
  SET_CHECKING_FLG_ATTACHED_FILE: PREFIX + 'SetCheckingFlgAttachedFile',
  SET_REGISTER_RESULT: PREFIX + 'SetRegisterResult',
  SET_DELETE_RESULT: PREFIX + 'SetDeleteResult',
  SET_BROADCAST_SAVE_NM: PREFIX + 'SetBroadcastSaveNm',
  CLEAR: PREFIX + 'Clear'
};

/**
 * コンテンツタイプ
 */
const CONTENTS = exports.CONTENTS = {
  INIT: 'init',
  SELECT: 'select',
  ENTER: 'enter',
  RESULT: 'result'
};
const FLAG = exports.FLAG = {
  ON: '1',
  OFF: '0'
};

/**
 * 報告対象選択モード
 */
const REPORT_TARGET_TYPE = exports.REPORT_TARGET_TYPE = {
  NEW: 'new',
  FOLLOWUP: 'followup'
};

/**
 * 会社／組織入力モード
 */
const KAISHA_SOSHIKI_SELECT_MODE = exports.KAISHA_SOSHIKI_SELECT_MODE = {
  SELECT: '1',
  INPUT: '2'
};

/**
 * 濃厚接触可能性者情報入力方法
 */
const CLOCECONTACT_ENTRY_TYPE = exports.CLOCECONTACT_ENTRY_TYPE = {
  DETAIL: 'Detail',
  SIMPLE: 'Simple'
};

/**
 * 利用許可属性
 */
const PERMISSION_KEY = exports.PERMISSION_KEY = {
  PROXY: 'proxy'
};

/**
 * 登録、更新、削除
 */
const ACTIONS = exports.ACTIONS = {
  register: 'register',
  update: 'update',
  delete: 'delete'
};
const INIT_ICON_COLUMN = exports.INIT_ICON_COLUMN = {
  dataKey: '',
  label: '',
  width: 42,
  minWidth: 42,
  maxWidth: 42,
  headerStyle: {
    textAlign: 'center',
    paddingLeft: 0
  },
  cellStyle: {
    textAlign: 'center',
    paddingLeft: 0
  }
};

/**
 * 初期State
 */
const INIT_STATE = {
  hasProxyPermission: false,
  dispContent: CONTENTS.INIT,
  action: '',
  additionals: [],
  reportTargetType: REPORT_TARGET_TYPE.NEW,
  kaishaSoshikiEntryMode: KAISHA_SOSHIKI_SELECT_MODE.SELECT,
  editing: false,
  entries: {
    reportTarget: {
      seimei: '',
      kaishaCd: '',
      soshikiCd: '',
      kaishaNm: '',
      soshikiNm: '',
      attributeCd: '',
      sentKaishaNm: ''
    },
    reporter: {
      firstReporterNm: '',
      firstReporterKaishaNm: '',
      firstReporterSoshikiNm: '',
      lastReporterSeimei: '',
      lastReportDateTime: ''
    },
    reportStatusCd: ''
  },
  checkingFlgs: {},
  initEntries: null,
  broadcastSaveNm: ''
};

/**
 * アクション定義
 */
const pandeReportActions = exports.pandeReportActions = (0, _reduxActions.createActions)({
  [TYPES.SET_CONTENT]: function () {
    return {
      content: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_KAISHA_SOSHIKI_ENTRY_MODE]: function () {
    return {
      value: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_HAS_PROXY_PERMISSION]: function () {
    return {
      hasPermission: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ADDITIONALS]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRIES]: function () {
    return {
      entries: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_KAISHA_SOSHIKI]: function () {
    return {
      kaishaSoshiki: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.APPEND_RECORD]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      record: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.MODIFY_RECORD]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      record: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.DELETE_RECORD]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      record: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_REPORT_STATUS]: function () {
    return {
      status: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_ENTRY]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_OBJECT_ENTRY]: function () {
    return {
      parentKey: arguments.length <= 0 ? undefined : arguments[0],
      key: arguments.length <= 1 ? undefined : arguments[1],
      value: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.SET_CHECKING_FLG]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_CHECKING_FLG_ATTACHED_FILE]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_REPORT_TARGET_TYPE]: function () {
    return {
      reportTargetType: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_REGISTER_RESULT]: function () {
    return {
      action: arguments.length <= 0 ? undefined : arguments[0],
      data: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_DELETE_RESULT]: function () {
    return {
      action: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_BROADCAST_SAVE_NM]: function () {
    return {
      broadcastSaveNm: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.CLEAR);

/**
 * Reducer定義
 */
const pandeReportReducer = exports.pandeReportReducer = (0, _reduxActions.handleActions)({
  [TYPES.SET_CONTENT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: action.payload.content
    });
  },
  [TYPES.CHANGE_KAISHA_SOSHIKI_ENTRY_MODE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      kaishaSoshikiEntryMode: action.payload.value
    });
  },
  [TYPES.SET_HAS_PROXY_PERMISSION]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      hasProxyPermission: action.payload.hasPermission
    });
  },
  [TYPES.SET_ADDITIONALS]: (state, action) => {
    let entries = _objectSpread({}, action.payload.entries);
    delete entries.additionalList;
    entries.reportTarget = nulltoEmptyString(entries.reportTarget);
    entries.reporter = nulltoEmptyString(entries.reporter);
    entries.reportTargetWorkplace = getReportTargetWorkplace(entries.reportTargetWorkplace);
    const checkingFlgs = createCheckingFlgs(entries);
    return _objectSpread(_objectSpread({}, state), {}, {
      additionals: action.payload.entries.additionalList,
      dispContent: CONTENTS.ENTER,
      reportTargetType: REPORT_TARGET_TYPE.NEW,
      editing: false,
      entries,
      checkingFlgs,
      initEntries: state.initEntries ? _objectSpread({}, state.initEntries) : _objectSpread({}, entries)
    });
  },
  [TYPES.SET_ENTRIES]: (state, action) => {
    let entries = _objectSpread({}, action.payload.entries);
    const reportTargetType = state.reportTargetType;
    const kaishaSoshikiEntryMode = getReportTargetKaishaSoshikiSelectMode(entries.reportTarget);
    entries.reportTarget = nulltoEmptyString(entries.reportTarget);
    entries.reporter = nulltoEmptyString(entries.reporter);
    entries.reportTargetWorkplace = getReportTargetWorkplace(entries.reportTargetWorkplace);
    entries.broadcastList = entries.broadcastList.map(e => nulltoEmptyString(e));
    entries.pandeEntryPlaceList = entries.pandeEntryPlaceList.map(e => nulltoEmptyString(e));
    entries.closecontactProperList = entries.closecontactProperList.map(e => nulltoEmptyString(e));
    entries.closecontactPartnerList = entries.closecontactPartnerList.map(e => nulltoEmptyString(e));
    entries.closecontactCustomerList = entries.closecontactCustomerList.map(e => {
      let item = nulltoEmptyString(e);
      item.kensaRstReportCd = item.kensaRstReportCd === _CodeConsts.CODE.PANDE_REPORT_CD.CODE_1;
      return item;
    });
    entries.attachedFileList = entries.attachedFileList.map(e => nulltoEmptyString(e));
    const checkingFlgs = createCheckingFlgs(entries);
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.ENTER,
      reportTargetType,
      kaishaSoshikiEntryMode,
      editing: true,
      entries,
      checkingFlgs
    });
  },
  [TYPES.SET_KAISHA_SOSHIKI]: (state, action) => {
    const kaishaSoshiki = action.payload.kaishaSoshiki;
    return _objectSpread(_objectSpread({}, state), {}, {
      entries: _objectSpread(_objectSpread({
        editing: true
      }, state.entries), {}, {
        reportTarget: _objectSpread(_objectSpread({}, state.entries.reportTarget), {}, {
          kaishaCd: kaishaSoshiki.kaishaCd,
          soshikiCd: kaishaSoshiki.soshikiCd
        })
      })
    });
  },
  [TYPES.APPEND_RECORD]: (state, action) => {
    const records = [...state.entries[action.payload.key]];
    records.push(action.payload.record);
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: records
      })
    });
  },
  [TYPES.MODIFY_RECORD]: (state, action) => {
    let records = state.entries[action.payload.key].slice();
    const idx = records.findIndex(r => r.key === action.payload.record.key);
    records.splice(idx, 1, _objectSpread({}, action.payload.record));
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: records
      })
    });
  },
  [TYPES.DELETE_RECORD]: (state, action) => {
    let records = state.entries[action.payload.key].slice();
    const idx = records.findIndex(r => r.key === action.payload.record.key);
    records.splice(idx, 1);
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: records
      })
    });
  },
  [TYPES.SET_REPORT_STATUS]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      reportStatusCd: _objectSpread({}, action.payload.status)
    });
  },
  [TYPES.SET_ENTRY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: action.payload.value
      }),
      checkingFlgs: _objectSpread(_objectSpread({}, state.checkingFlgs), {}, {
        [action.payload.key]: false
      })
    });
  },
  [TYPES.SET_OBJECT_ENTRY]: (state, action) => {
    const parentKey = action.payload.parentKey;
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [parentKey]: _objectSpread(_objectSpread({}, state.entries[parentKey]), {}, {
          [action.payload.key]: action.payload.value
        })
      })
    });
  },
  [TYPES.SET_CHECKING_FLG]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      checkingFlgs: _objectSpread(_objectSpread({}, state.checkingFlgs), {}, {
        [action.payload.key]: action.payload.value
      }),
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        [action.payload.key]: state.initEntries[action.payload.key]
      })
    });
  },
  [TYPES.SET_CHECKING_FLG_ATTACHED_FILE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      editing: true,
      checkingFlgs: _objectSpread(_objectSpread({}, state.checkingFlgs), {}, {
        [action.payload.key]: action.payload.value
      })
    });
  },
  [TYPES.CHANGE_REPORT_TARGET_TYPE]: (state, action) => {
    const initEntries = _objectSpread({}, state.initEntries);
    const checkingFlgs = createCheckingFlgs(initEntries);
    return _objectSpread(_objectSpread({}, INIT_STATE), {}, {
      dispContent: action.payload.reportTargetType === REPORT_TARGET_TYPE.FOLLOWUP ? CONTENTS.SELECT : CONTENTS.ENTER,
      additionals: state.additionals,
      reportTargetType: action.payload.reportTargetType ? action.payload.reportTargetType : INIT_STATE.reportTargetType,
      hasProxyPermission: state.hasProxyPermission,
      entries: initEntries,
      checkingFlgs,
      initEntries
    });
  },
  [TYPES.SET_REGISTER_RESULT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.RESULT,
      action: action.payload.action,
      editing: false,
      entries: _objectSpread(_objectSpread({}, state.entries), {}, {
        reportNo: action.payload.data.reportNo
      })
    });
  },
  [TYPES.SET_DELETE_RESULT]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: CONTENTS.RESULT,
      action: action.payload.action,
      editing: false
    });
  },
  [TYPES.SET_BROADCAST_SAVE_NM]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      broadcastSaveNm: action.payload.broadcastSaveNm
    });
  },
  [TYPES.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  }
}, INIT_STATE);
const nulltoEmptyString = src => {
  let dst = _objectSpread({}, src);
  Object.keys(dst).forEach(key => {
    switch (typeof dst[key]) {
      case 'number':
      case 'boolean':
        break;
      default:
        if (!dst[key]) {
          dst[key] = '';
        }
        break;
    }
  });
  return dst;
};
const createCheckingFlgs = entries => {
  let checkingFlgs = entries.checkingFlgs ? JSON.parse(entries.checkingFlgs) : {};
  Object.keys(entries).forEach(key => {
    if (key !== 'checkingFlgs' && typeof checkingFlgs[key] === 'undefined' && (entries[key] === null || typeof entries[key] !== 'object')) {
      checkingFlgs[key] = false;
    }
    if (!entries[key]) {
      entries[key] = '';
    }
  });
  const key = _pandeReportUtil.default.getAttachedFileCheckingFlgKey(_CodeConsts.CODE.PANDE_FILE_TYPE.CODE_2);
  if (typeof checkingFlgs[key] === 'undefined') {
    checkingFlgs[key] = false;
  }
  return checkingFlgs;
};
const getReportTargetWorkplace = entries => {
  let newEntries = nulltoEmptyString(entries);
  newEntries.siteSelectCd = entries.siteOtherNm ? _WorkplaceInfo.SITE_SELECT_CODE.INPUT : _WorkplaceInfo.SITE_SELECT_CODE.SELECT;
  return newEntries;
};
const getReportTargetKaishaSoshikiSelectMode = entries => {
  return entries.kaishaCd && entries.soshikiCd ? KAISHA_SOSHIKI_SELECT_MODE.SELECT : KAISHA_SOSHIKI_SELECT_MODE.INPUT;
};